import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const parkingSpaceApi = createApi({
  reducerPath: 'parkingSpaceApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['parkingSpace'],
  endpoints: (builder) => ({
    findByParkingLocationId: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.ParkingSpaceLocationDocumentController.findByParkingLocationId}${body.parkingLocationId}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateParkingSpaceLocationImage: builder.mutation({
      query(body) {
        return {
          url: spotFinder.ParkingSpaceLocationDocumentController.updateParkingSpaceLocationImage,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    uploadParkingSpaceLocationImage: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.ParkingSpaceLocationDocumentController.uploadParkingSpaceLocationImage}${body.parkingLocationId}/${body.docType}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

    deleteParkingSpaceLocationImage: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.ParkingSpaceLocationDocumentController.deleteParkingSpaceLocationImage}/${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindByParkingLocationIdMutation,
  useUpdateParkingSpaceLocationImageMutation,
  useUploadParkingSpaceLocationImageMutation,
  useDeleteParkingSpaceLocationImageMutation,
} = parkingSpaceApi;
